import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { getActiveSpecialGroups } from "../api/programEvents";

const useSpecialGroup = () => {
    const [specialGroupList, setSpecialGroupList] = useState([]);
    const [loading, setLoading] = useState(true);

    const getSpecialGroupListAsync = useCallback(async (tokenSource) => {
        try {
            const response = await getActiveSpecialGroups(tokenSource.token);
            setSpecialGroupList(response.data.result);
        } catch (ex) {
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        const tokenSource = axios.CancelToken.source();
        getSpecialGroupListAsync(tokenSource);
        return () => {
            tokenSource.cancel();
        };
    }, [getSpecialGroupListAsync]);

    return {
        specialGroupList,
        loading,
    };
};

export default useSpecialGroup;
